"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Agent responses
 *
 * @link {https://github.com/dotse/bredbandskollen/wiki/Agent-API-v2#events-that-the-gui-can-receive} Documentation
 */
var AgentResponse;
(function (AgentResponse) {
    AgentResponse["CONFIGURATION"] = "configuration";
    AgentResponse["TASK_COMPLETE"] = "taskComplete";
    AgentResponse["TASK_ERROR"] = "taskError";
    AgentResponse["TASK_PROGRESS"] = "taskProgress";
    AgentResponse["TASK_START"] = "taskStart";
    AgentResponse["AGENT_READY"] = "agentReady";
    AgentResponse["SET_INFO"] = "setInfo";
    AgentResponse["REPORT"] = "report";
    AgentResponse["MEASUREMENT_INFO"] = "measurementInfo";
    AgentResponse["MEASUREMENT_LIST"] = "measurementList";
    AgentResponse["CONNECTION_INFO"] = "connectionInfo";
    AgentResponse["HOST_CHECK"] = "hostCheck";
    AgentResponse["DEBUG"] = "debug";
})(AgentResponse || (AgentResponse = {}));
exports.default = AgentResponse;
//# sourceMappingURL=AgentResponse.js.map